import { addIcon, AIIcon, closeIcon } from "assets/icons";
import { Button, LoadingButton, TextAreaAutoAdjust } from "components/form";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { FaArrowLeft, FaArrowRight, FaEye, FaTimes } from "react-icons/fa";
import { MdAdd } from "react-icons/md";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import DropdownQuestionType from "./DropdownQuestionType";
import {
  handleDecryptionParams,
  handleEncryptionParams,
} from "utils/dataCipherHelper";
import { isArrayEmpty, isObjectEmpty, isTrue } from "utils/commonHelper";
import MultipleFieldQuestion from "./MultipleFieldQuestion";
import TextFieldQuestion from "./TextFieldQuestion";
import RankOrderQuestion from "./RankOrderQuestion";
import SliderQuestion from "./SliderQuestion";
import PictureQuestion from "./PictureQuestion";
import CustomModal from "components/modals/CustomModal";
import AddNewBlock from "./AddNewBlock";
import RenameExistblock from "./RenameExistblock";
import { toastMessage } from "utils/toastMessageHelper";
import commonMessages from "constant/commonMessage";
import { generateUniqueId, surveyFormValue } from "constant/staticData";
import { RxCrossCircled } from "react-icons/rx";
import DeleteModal from "components/modals/DeleteModal";
import { getFromLocal } from "config/axiosInstance";
import {
  createSurveyMcqApi,
  surveyDraftQuestionListApi,
  surveyTemplateQuestionListApi,
} from "services/survey";
import SurveyPreview from "../surveyPreview/SurveyPreview";
import { DeviceFrameset } from "react-device-frameset";
import AiSuveyModel from "./AiSuveyModel";
import RatingQuestion from "./RatingQuestion";
import {
  DndContext,
  DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { toast } from "sonner";
import { IoMdArrowForward } from "react-icons/io";
import { IoArrowBackSharp, IoEyeOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const { SURVEY_BLOCK_QUESTION_LIMIT, SURVEY_BLOCK_MORE_THAN_LIMIT } =
  commonMessages;

const CustomizeQuestionIndex = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const navigateRoute = useNavigate();
  const getParamsData = handleDecryptionParams(
    searchParams.get("data"),
    setSearchParams
  );

  const selectedSurveyId = getParamsData?.isTemplate
    ? getParamsData?.surveySlug
    : getParamsData?.surveyId;

  const [showDropdown, setShowDropdown] = useState(true);
  const [renameBlockTitleModal, setRenameBlockTitleModal] = useState(false);
  const [blockArray, setBlockArray] = useState([
    {
      totalQuestion: 0,
      name: "Section 1",
      // blockUniqId: generateUniqueId("Block"),
    },
  ]);
  const [selectedBlock, setSelectedBlock] = useState("Section 1");

  const [surveyQuestionArray, setSurveyQuestionArray] = useState({
    ["Section 1"]: [],
  });

  const [addBlockModel, setAddBlockModel] = useState(false);
  const [deleteBlockModel, setDeleteBlockModel] = useState(false);
  const [deletedBlock, setDeletedBlock] = useState("");
  const [mcqQuestionUploadLoader, setMcqQuestionUploadLoader] = useState(false);
  const [surveyPreviewModel, setSurveyPreviewModel] = useState(false);
  const [surveyAIModel, setSurveyAIModel] = useState(false);
  const [selectedQuestForSkipSurvey, setSelectedQuestForSkipSurvey] =
    useState();

  const [isDaftModalOpen, setIsDaftModalOpen] = useState(false);
  const [draftButtonLoading, setDraftButtonLoading] = useState(false);

  const [dropdownQuestionArray, setDropdownQuestionArray] = useState();

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const [titleValue, setTitleValue] = useState("");

  //------------------------------------ handle function -----------------------------------//

  // show dropdown handler
  const handleShowQuestionDropdown = () => {
    if (Array.isArray(blockArray) && blockArray?.length === 0) {
      toastMessage(
        "First Please add Question block",
        "warning",
        "question-block"
      );

      return;
    }

    // Check if the selected block has more than 15 questions
    const questionsInSelectedBlock =
      surveyQuestionArray[selectedBlock]?.length || 0;

    if (
      questionsInSelectedBlock >=
      (surveyFormValue?.PER_SURVEY_BLOCK_QUESTION_LIMIT || 15)
    ) {
      toastMessage(
        SURVEY_BLOCK_QUESTION_LIMIT,
        "warning",
        "addSelectedBlockQuestion"
      );
      return;
    }
    setShowDropdown(true);
  };

  // Rename block title handler
  const renameBlockTitleHandler = (blockTitle) => {
    if (selectedBlock === blockTitle) {
      setRenameBlockTitleModal(true);
    }
  };

  // skipSurvey onClick handler for handle data
  const skipSurveyOnClickHandler = (selectedQues, setModal) => {
    setSelectedQuestForSkipSurvey(selectedQues);

    const selectedQuestionNumber =
      allPrevQuestionCount + selectedQues?.questionNumber || null;
    // const quesArr = surveyQuestionArray[selectedBlock];

    const quesArr = Object.values(surveyQuestionArray).reduce((acc, block) => {
      return acc.concat(block);
    }, []);

    let questForDropdown = quesArr?.map((ques, i) => {
      return {
        value: i + 1,
        questionNumber: i + 1,
        question: ques?.question,
        // questionNumber: allPrevQuestionCount + ques?.questionNumber,
      };
    });

    questForDropdown = questForDropdown?.filter(
      (el) => el?.questionNumber > selectedQuestionNumber
    );

    let finalDropDown = [
      ...questForDropdown,
      { questionNumber: "", value: "isSurveyEnd", question: "End the Survey" },
      { questionNumber: "", value: "isBlockEnd", question: "End the Section" },
    ];

    setDropdownQuestionArray(finalDropDown);
    setModal(true);
  };

  // get survey question handler
  const getSurveyQuestion = (data, indexValue) => {
    if (!data || isObjectEmpty(data) || !data.questionType) {
      return null; // Return `null` for proper JSX rendering
    }

    const surveyQuestion = {
      multiple: (
        <MultipleFieldQuestion
          data={data}
          indexValue={indexValue}
          blockArray={blockArray}
          setBlockArray={setBlockArray}
          selectedBlock={selectedBlock}
          skipDropdownList={dropdownQuestionArray}
          prevQuestionCount={allPrevQuestionCount}
          surveyQuestionArray={surveyQuestionArray}
          setSurveyQuestionArray={setSurveyQuestionArray}
          skipSurveyOnClickHandler={skipSurveyOnClickHandler}
          skipSurveySelectedQues={selectedQuestForSkipSurvey}
        />
      ),
      single: (
        <MultipleFieldQuestion
          data={data}
          indexValue={indexValue}
          blockArray={blockArray}
          selectedBlock={selectedBlock}
          setBlockArray={setBlockArray}
          skipDropdownList={dropdownQuestionArray}
          prevQuestionCount={allPrevQuestionCount}
          surveyQuestionArray={surveyQuestionArray}
          setSurveyQuestionArray={setSurveyQuestionArray}
          skipSurveyOnClickHandler={skipSurveyOnClickHandler}
          skipSurveySelectedQues={selectedQuestForSkipSurvey}
        />
      ),
      text: (
        <TextFieldQuestion
          data={data}
          blockArray={blockArray}
          indexValue={indexValue}
          selectedBlock={selectedBlock}
          setBlockArray={setBlockArray}
          prevQuestionCount={allPrevQuestionCount}
          surveyQuestionArray={surveyQuestionArray}
          setSurveyQuestionArray={setSurveyQuestionArray}
        />
      ),
      image: (
        <PictureQuestion
          data={data}
          indexValue={indexValue}
          blockArray={blockArray}
          selectedBlock={selectedBlock}
          setBlockArray={setBlockArray}
          skipDropdownList={dropdownQuestionArray}
          prevQuestionCount={allPrevQuestionCount}
          surveyQuestionArray={surveyQuestionArray}
          setSurveyQuestionArray={setSurveyQuestionArray}
          skipSurveySelectedQues={selectedQuestForSkipSurvey}
          skipSurveyOnClickHandler={skipSurveyOnClickHandler}
        />
      ),
      rankorder: (
        <RankOrderQuestion
          data={data}
          indexValue={indexValue}
          blockArray={blockArray}
          selectedBlock={selectedBlock}
          setBlockArray={setBlockArray}
          prevQuestionCount={allPrevQuestionCount}
          surveyQuestionArray={surveyQuestionArray}
          setSurveyQuestionArray={setSurveyQuestionArray}
        />
      ),
      slider: (
        <SliderQuestion
          data={data}
          indexValue={indexValue}
          blockArray={blockArray}
          selectedBlock={selectedBlock}
          setBlockArray={setBlockArray}
          skipDropdownList={dropdownQuestionArray}
          prevQuestionCount={allPrevQuestionCount}
          surveyQuestionArray={surveyQuestionArray}
          setSurveyQuestionArray={setSurveyQuestionArray}
          skipSurveyOnClickHandler={skipSurveyOnClickHandler}
          skipSurveySelectedQues={selectedQuestForSkipSurvey}
        />
      ),
      rating: (
        <RatingQuestion
          data={data}
          indexValue={indexValue}
          blockArray={blockArray}
          selectedBlock={selectedBlock}
          setBlockArray={setBlockArray}
          skipDropdownList={dropdownQuestionArray}
          prevQuestionCount={allPrevQuestionCount}
          surveyQuestionArray={surveyQuestionArray}
          setSurveyQuestionArray={setSurveyQuestionArray}
          skipSurveyOnClickHandler={skipSurveyOnClickHandler}
          skipSurveySelectedQues={selectedQuestForSkipSurvey}
        />
      ),
    };

    // Return the matching component or null if not found
    return surveyQuestion[data.questionType] || null;
  };

  // Add new Block
  // const addNewBlockHandler = () => {
  //   setAddBlockModel(true);
  // };

  // Close Model
  const closeModal = () => {
    setAddBlockModel(false);
    setRenameBlockTitleModal(false);
    setDeleteBlockModel(false);
    setSurveyPreviewModel(false);
    setSurveyAIModel(false);
  };

  // Delete block handler
  const deleteBlockHandler = (blockName) => {
    setDeletedBlock(blockName);
    setDeleteBlockModel(true);
  };

  // Selected Delete Block Handler
  const selectedDeleteBlockHandler = () => {
    if (deletedBlock && isTrue(deleteBlockModel)) {
      // Delete the block only if it exists in the array
      if (surveyQuestionArray[deletedBlock]) {
        delete surveyQuestionArray[deletedBlock];
      }
    }

    const blockIndex = blockArray?.findIndex((el) => el?.name === deletedBlock);

    // Clone and filter out the deleted block
    const blockArrayClone = blockArray
      ?.filter((el) => el?.name !== deletedBlock)
      ?.map((el) => el);

    setBlockArray(blockArrayClone);

    if (blockArrayClone?.length > 0) {
      const lastBlock = blockArrayClone[blockArrayClone.length - 1];
      if (lastBlock?.name) {
        setSelectedBlock(lastBlock.name); // <-- Replace this with your actual setter
      }
    } else {
      setSelectedBlock(null); // Or handle empty case as needed
    }

    closeModal();
  };

  // errorHandler function
  const errorHandler = () => {
    let errors = {};
    let isValid = true;

    // blockArray.forEach((block) => {
    //   if (!block?.title) {
    //     isValid = false;
    //     toast.error(`Please Enter Title of  ${block?.name}`);
    //     return;
    //   }
    // });

    for (let key in surveyQuestionArray) {
      if (surveyQuestionArray[key]?.length > 0) {
        surveyQuestionArray[key]?.forEach((el) => {
          if (el?.questionType === "text" && !el?.question) {
            isValid = false;
            setSelectedBlock(key);
            toast.error(
              `${t(`CUSTOMIZATION_QUESTION.pleaseEnterQuestionNumber`)} ${
                el?.questionNumber + allPrevQuestionCount
              }`
            );
            return;
          }

          if (el?.questionType === "multiple") {
            if (el?.option?.length > 0) {
              el?.option?.forEach((opt, ind) => {
                if (!opt?.optionValue) {
                  isValid = false;
                  setSelectedBlock(key);
                  toast.error(
                    `${t(`CUSTOMIZATION_QUESTION.pleaseEnterOptionNumber`)} ${
                      ind + 1
                    } ${t(`CUSTOMIZATION_QUESTION.questionNumber`)} ${
                      el?.questionNumber + allPrevQuestionCount
                    }`
                  );
                }
                return;
              });
            } else if (!el?.question) {
              isValid = false;
              setSelectedBlock(key);
              toast.error(
                `${t(`CUSTOMIZATION_QUESTION.pleaseEnterQuestionNumber`)} ${
                  el?.questionNumber + allPrevQuestionCount
                }`
              );
              return;
            }
          }

          if (el?.questionType === "image") {
            if (!el?.question) {
              isValid = false;
              setSelectedBlock(key);
              toast.error(
                `${t(`CUSTOMIZATION_QUESTION.pleaseEnterQuestionNumber`)} ${
                  el?.questionNumber + allPrevQuestionCount
                }`
              );
              return;
            }
            // else if (!el?.questionImage) {
            //   isValid = false;
            //   setSelectedBlock(key);
            //   toast.error(
            //     `Please upload image of  question number ${
            //       el?.questionNumber + allPrevQuestionCount
            //     }`
            //   );
            //   return;
            // }
            else if (el?.option?.length > 0) {
              el?.option?.forEach((opt, ind) => {
                if (!opt?.optionValue) {
                  isValid = false;
                  setSelectedBlock(key);
                  toast.error(
                    `${t(`CUSTOMIZATION_QUESTION.pleaseEnterOptionNumber`)} ${
                      ind + 1
                    } ${t(`CUSTOMIZATION_QUESTION.questionNumber`)} ${
                      el?.questionNumber + allPrevQuestionCount
                    }`
                  );
                  return;
                }

                if (!opt?.optionImage) {
                  isValid = false;
                  setSelectedBlock(key);
                  toast.error(
                    `${t(`CUSTOMIZATION_QUESTION.selectOptionImage`)} ${
                      ind + 1
                    } ${t(`CUSTOMIZATION_QUESTION.questionNumber`)} ${
                      el?.questionNumber + allPrevQuestionCount
                    }`
                  );
                  return;
                }
              });
            }
          }

          if (el?.questionType === "rankorder") {
            if (el?.option?.length > 0) {
              el?.option?.forEach((opt, ind) => {
                if (!opt?.optionValue) {
                  isValid = false;
                  setSelectedBlock(key);
                  toast.error(
                    `${t(`CUSTOMIZATION_QUESTION.pleaseEnterOptionNumber`)} ${
                      ind + 1
                    } ${t(`CUSTOMIZATION_QUESTION.questionNumber`)} ${
                      el?.questionNumber + allPrevQuestionCount
                    }`
                  );
                  return;
                }
              });
            }
            if (!el?.question) {
              isValid = false;
              setSelectedBlock(key);
              toast.error(
                `${t(`CUSTOMIZATION_QUESTION.pleaseEnterQuestionNumber`)} ${
                  el?.questionNumber
                }`
              );
              return;
            }
          }

          if (el?.questionType === "slider") {
            if (el?.option?.length > 0) {
              el?.option?.forEach((opt, ind) => {
                if (!opt?.optionValue) {
                  isValid = false;
                  setSelectedBlock(key);
                  toast.error(
                    `${t(`CUSTOMIZATION_QUESTION.pleaseEnterOptionNumber`)} ${
                      ind + 1
                    } ${t(`CUSTOMIZATION_QUESTION.questionNumber`)} ${
                      el?.questionNumber + allPrevQuestionCount
                    }`
                  );
                  return;
                }
              });
            }
            if (!el?.question) {
              isValid = false;
              setSelectedBlock(key);
              toast.error(
                `${t(`CUSTOMIZATION_QUESTION.pleaseEnterQuestionNumber`)} ${
                  el?.questionNumber + allPrevQuestionCount
                }`
              );
              return;
            }
          }

          if (el?.questionType === "rating") {
            if (el?.option?.length > 0) {
              el?.option?.forEach((opt, ind) => {
                if (!opt?.optionValue) {
                  isValid = false;
                  setSelectedBlock(key);
                  toast.error(
                    `${t(`CUSTOMIZATION_QUESTION.pleaseEnterOptionNumber`)} ${
                      ind + 1
                    } ${t(`CUSTOMIZATION_QUESTION.questionNumber`)} ${
                      el?.questionNumber + allPrevQuestionCount
                    }`
                  );
                  return;
                }
              });
            }
            if (!el?.question) {
              isValid = false;
              setSelectedBlock(key);
              toast.error(
                `${t(`CUSTOMIZATION_QUESTION.pleaseEnterQuestionNumber`)} ${
                  el?.questionNumber
                }`
              );
              return;
            }
          }
        });
      } else {
        isValid = false;
        toast.error(t(`CUSTOMIZATION_QUESTION.pleaseAddQuestionNumber`));
        return;
      }
    }
    return isValid;
  };

  const updateQuestionNumberHandlerAfterSubmit = (
    sectionKey,
    el,
    blockArrayData
  ) => {
    let questionNumber = 0;
    let i = blockArrayData?.findIndex((block) => block?.name === sectionKey);
    if (i === 0) {
      questionNumber = el?.questionNumber;
    } else {
      let prevTotalQues = 0;

      for (let index = 0; index < i; index++) {
        prevTotalQues = prevTotalQues + blockArrayData[index]?.totalQuestion;
      }
      questionNumber = +el?.questionNumber - prevTotalQues;
    }
    return questionNumber;
  };

  const updateQuestionNumberHandler = (sectionKey, el) => {
    let questionNumber = 0;
    let i = blockArray?.findIndex((block) => block?.name === sectionKey);
    if (i === 0) {
      questionNumber = el?.questionNumber;
    } else {
      let prevTotalQues = 0;

      for (let index = 0; index < i; index++) {
        prevTotalQues = prevTotalQues + blockArray[index]?.totalQuestion;
      }
      questionNumber = prevTotalQues + el?.questionNumber;
    }
    return questionNumber;
  };

  // set survey data handler for send data in to backend
  const setSurveyDataHandler = () => {
    let reqData;
    let questionArrayData = {};
    let updateSurveyQuestionData = {};

    Object.keys(surveyQuestionArray)?.forEach((key) => {
      updateSurveyQuestionData = {
        ...updateSurveyQuestionData,
        [key]: surveyQuestionArray[key]?.map((el, i) => {
          return {
            ...el,
            id: updateQuestionNumberHandler(key, el),
            questionNumber: updateQuestionNumberHandler(key, el),
          };
        }),
      };
    });

    if (getParamsData?.isDraft) {
      Object.keys(updateSurveyQuestionData).forEach((key) => {
        questionArrayData = {
          ...questionArrayData,
          [key]: updateSurveyQuestionData[key].map(
            ({
              _id,
              block,
              researcherId,
              __v,
              createdAt,
              questionMapping,
              ...rest
            }) => {
              if (rest?.option?.length > 0) {
                return {
                  ...rest,
                  option: rest?.option?.map(
                    ({ _id, ...optionRest }) => optionRest
                  ),
                };
              } else {
                return {
                  ...rest,
                };
              }
            }
          ),
        };
      });

      reqData = {
        isDraft: true,
        token: getFromLocal() || "",
        surveyMcq: questionArrayData,
        surveyId: getParamsData?.surveyId,
        titleArray: blockArray.map((el) => {
          return {
            block: el?.name,
            title: el?.title || "",
          };
        }),
      };
    } else {
      if (getParamsData?.isTemplate) {
        Object.keys(updateSurveyQuestionData).forEach((key) => {
          questionArrayData = {
            ...questionArrayData,
            [key]: updateSurveyQuestionData[key].map(
              ({ _id, block, ...rest }) => {
                if (rest?.option?.length > 0) {
                  return {
                    ...rest,
                    option: rest?.option?.map(
                      ({ _id, id, ...optionRest }) => optionRest
                    ),
                  };
                } else {
                  return {
                    ...rest,
                  };
                }
              }
            ),
          };
        });
      }

      reqData = {
        isDraft: true,
        surveyId: selectedSurveyId,
        token: getFromLocal() || "",
        surveyMcq: getParamsData?.isTemplate
          ? questionArrayData
          : updateSurveyQuestionData,
        titleArray: blockArray.map((el) => {
          return {
            block: el?.name,
            title: el?.title || "",
          };
        }),
      };
    }

    return reqData;
  };

  // Mcq Upload handler
  const createSurveyHandler = async () => {
    if (errorHandler()) {
      try {
        setMcqQuestionUploadLoader(true);
        let reqData = setSurveyDataHandler();

        const responseData = await createSurveyMcqApi(reqData);
        const { message = "", status: requstStatus } = responseData;

        if (requstStatus === 200) {
          toastMessage(message, "success", "createMcqSurvey");
        }
        const currentParamsData = {
          surveyId: getParamsData?.isTemplate
            ? getParamsData?.surveySlug
            : getParamsData?.surveyId,
          stepper: 3,
          isDraft: true,
        };
        const currentEncryptedParams = handleEncryptionParams(
          currentParamsData,
          null
        );

        navigateRoute(`?data=${currentEncryptedParams}`, {
          replace: true,
        });

        const paramsData = {
          surveySlug: getParamsData?.isDraft
            ? getParamsData?.surveyId
            : selectedSurveyId,
          stepper: 4,
        };

        const encryptedParams = handleEncryptionParams(
          paramsData,
          searchParams
        );
        setSearchParams(encryptedParams);
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setMcqQuestionUploadLoader(false);
      }
    }
  };

  // Exit Survey Handler
  const exitSurveyHandler = () => {
    searchParams.delete("data");
    setSearchParams(searchParams);
    navigateRoute("/dashboard/create-survey");
  };

  // Function for save data in Draft
  const saveSurveyInDraftHandler = async () => {
    try {
      setDraftButtonLoading(true);
      let reqData,
        questionArrayData = {},
        updateSurveyQuestionData = {};

      Object.keys(surveyQuestionArray)?.forEach((key) => {
        updateSurveyQuestionData = {
          ...updateSurveyQuestionData,
          [key]: surveyQuestionArray[key]?.map((el) => {
            return {
              ...el,
              questionNumber: updateQuestionNumberHandler(key, el),
            };
          }),
        };
      });

      if (getParamsData?.isDraft) {
        Object.keys(updateSurveyQuestionData).forEach((key) => {
          questionArrayData = {
            ...questionArrayData,
            [key]: updateSurveyQuestionData[key].map(
              ({
                _id,
                block,
                researcherId,
                __v,
                createdAt,
                questionMapping,
                ...rest
              }) => {
                if (rest?.option?.length > 0) {
                  return {
                    ...rest,
                    option: rest?.option?.map(
                      ({ _id, ...optionRest }) => optionRest
                    ),
                  };
                } else {
                  return {
                    ...rest,
                  };
                }
              }
            ),
          };
        });

        reqData = {
          isDraft: true,
          token: getFromLocal() || "",
          surveyMcq: questionArrayData,
          surveyId: getParamsData?.surveyId,
          titleArray: blockArray.map((el) => {
            return {
              block: el?.name,
              title: el.title,
            };
          }),
        };
      } else {
        if (getParamsData?.isTemplate) {
          Object.keys(updateSurveyQuestionData).forEach((key) => {
            questionArrayData = {
              ...questionArrayData,
              [key]: updateSurveyQuestionData[key].map(
                ({ _id, block, ...rest }) => {
                  if (rest?.option?.length > 0) {
                    return {
                      ...rest,
                      option: rest?.option?.map(
                        ({ _id, id, ...optionRest }) => optionRest
                      ),
                    };
                  } else {
                    return {
                      ...rest,
                    };
                  }
                }
              ),
            };
          });
        }

        reqData = {
          isDraft: true,
          surveyId: selectedSurveyId,
          token: getFromLocal() || "",
          surveyMcq: getParamsData?.isTemplate
            ? questionArrayData
            : updateSurveyQuestionData,
          titleArray: blockArray.map((el) => {
            return {
              block: el?.name,
              title: el.title,
            };
          }),
        };
      }

      const responseData = await createSurveyMcqApi(reqData);
      const { message = "", status: requstStatus } = responseData;
      if (requstStatus === 200) {
        toastMessage(message, "success", "createMcqSurvey");
        navigateRoute("/dashboard/create-survey");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setDraftButtonLoading(false);
    }
    // }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    // If the item is dropped over another item and they are not the same
    if (active.id !== over?.id) {
      // Find the current block and the item being dragged
      const currentBlockQuestions = surveyQuestionArray[selectedBlock];

      // Find the active item (the item being dragged)
      const activeIndex = currentBlockQuestions.findIndex(
        (question) => question?.questionNumber === active.id
      );

      // Find the item that the active item is dropped on (over item)
      const overIndex = currentBlockQuestions.findIndex(
        (question) => question?.questionNumber === over?.id
      );

      // Reorder the array using arrayMove
      const reorderedQuestions = arrayMove(
        currentBlockQuestions,
        activeIndex,
        overIndex
      );

      // Update the questionNumber for each question based on its new position
      const updatedQuestions = reorderedQuestions.map((question, index) => ({
        ...question,
        questionNumber: index + 1, // Set the new question number based on its index
      }));

      // Update the surveyQuestionArray with the new order and updated question numbers
      setSurveyQuestionArray((prev) => ({
        ...prev,
        [selectedBlock]: updatedQuestions,
      }));
    }
  };

  // Function for get question details
  const getDraftQuestionList = async () => {
    try {
      let sendParamsData = {
        token: getFromLocal(),
        surveyId: getParamsData?.surveyId,
      };

      let responseData = await surveyDraftQuestionListApi(sendParamsData);
      const { message = "", status } = responseData;
      if (status === 200) {
        let updatedQuestionDataOfSurvey = {};
        let blockData = responseData?.data?.blocks;
        let questionData = responseData?.data?.surveyMcq;
        let updatedBlockArrayWithTitle = responseData?.data?.titleArray;

        let updateBlockArray = blockData?.map((el) => {
          return {
            totalQuestion: questionData[el]?.length,
            name: el,
            title: updatedBlockArrayWithTitle.find(
              (tBlock) => tBlock?.block === el
            )?.title,
          };
        });

        Object.keys(questionData)?.forEach((key) => {
          updatedQuestionDataOfSurvey = {
            ...updatedQuestionDataOfSurvey,
            [key]: questionData[key]?.map((el) => {
              return {
                ...el,
                questionNumber: updateQuestionNumberHandlerAfterSubmit(
                  key,
                  el,
                  updateBlockArray
                ),
              };
            }),
          };
        });

        if (updateBlockArray?.length === 1) {
          setSelectedBlock(updateBlockArray[0]?.name);
        } else {
          setSelectedBlock(
            updateBlockArray[updateBlockArray?.length - 1]?.name
          );
        }
        setBlockArray(updateBlockArray);
        setSurveyQuestionArray({ ...updatedQuestionDataOfSurvey });
      } else {
        toastMessage(message, "error", "createMcqSurvey");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (getParamsData?.surveyId && getParamsData?.isDraft) {
      getDraftQuestionList();
    }
    // eslint-disable-next-line
  }, [getParamsData?.surveyId, getParamsData?.isDraft]);

  // Function for get template question list
  const getTemplateQuestionList = async () => {
    try {
      let sendParamsData = {
        token: getFromLocal(),
        surveySlug: getParamsData?.templateSlug,
      };

      let responseData = await surveyTemplateQuestionListApi(sendParamsData);

      const { message = "", status } = responseData;
      if (status === 200) {
        let updatedQuestionDataOfSurvey = {};

        let blockData = responseData?.data?.blocks;
        let questionData = responseData?.data?.surveyMcq;

        // let updatedBlockArrayWithTitle = responseData?.data?.titleArray;

        let updateBlockArray = blockData?.map((el) => {
          return {
            totalQuestion: questionData[el]?.length,
            name: el,
            // title: updatedBlockArrayWithTitle.find(
            //   (tBlock) => tBlock?.block === el
            // )?.title,
            title: "",
          };
        });

        Object.keys(questionData)?.forEach((key) => {
          updatedQuestionDataOfSurvey = {
            ...updatedQuestionDataOfSurvey,
            [key]: questionData[key]?.map((el) => {
              return {
                ...el,
                questionNumber: updateQuestionNumberHandlerAfterSubmit(
                  key,
                  el,
                  updateBlockArray
                ),
              };
            }),
          };
        });

        if (updateBlockArray?.length === 1) {
          setSelectedBlock(updateBlockArray[0]?.name);
        } else {
          setSelectedBlock(
            updateBlockArray[updateBlockArray?.length - 1]?.name
          );
        }

        setBlockArray(updateBlockArray);
        setSurveyQuestionArray({ ...updatedQuestionDataOfSurvey });

        // // let updatedBlockArrayWithTitle = responseData?.data?.titleArray;

        // // console.log("TITLE ARRAY", updatedBlockArrayWithTitle);

        // let updateBlockArray = blockData?.map((el) => {
        //   return {
        //     totalQuestion: questionData[el]?.length,
        //     name: el,
        //     // title: updatedBlockArrayWithTitle.find(
        //     //   (tBlock) => tBlock?.block === el
        //     // )?.title,
        //   };
        // });

        // if (updateBlockArray?.length === 1) {
        //   setSelectedBlock(updateBlockArray[0]?.name);
        // } else {
        //   setSelectedBlock(
        //     updateBlockArray[updateBlockArray?.length - 1]?.name
        //   );
        // }

        // setBlockArray(updateBlockArray);
        // setSurveyQuestionArray({ ...questionData });
      } else {
        toastMessage(message, "error", "createMcqSurvey");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (getParamsData?.isTemplate) {
      getTemplateQuestionList();
    }

    // eslint-disable-next-line
  }, [getParamsData?.isTemplate]);

  // useMemo for get all question count before selected block
  const allPrevQuestionCount = useMemo(() => {
    let count = 0;
    let currentIndex = blockArray?.findIndex(
      (el) => el?.name === selectedBlock
    );

    for (let i = 0; i < currentIndex; i++) {
      count = count + blockArray[i]?.totalQuestion;
    }
    return count;
  }, [selectedBlock, blockArray]);

  const blockTitleOnChangeHandler = (e, block) => {
    const { value } = e.target;
    let blockArrayClone = blockArray.map((el) => el);
    let index = blockArrayClone.findIndex((el) => el?.name === block);
    let findSelectedBlock = blockArrayClone.find((el) => el?.name === block);

    findSelectedBlock = { ...findSelectedBlock, title: value };
    blockArrayClone[index] = findSelectedBlock;
    setTitleValue(value);
    setBlockArray(blockArrayClone);
  };

  const titleValueHandler = (block) => {
    let index = blockArray.findIndex((el) => el?.name === block);
    let selectedBlockData = blockArray[index];
    let title = selectedBlockData?.title || undefined;
    if (!title) {
      return titleValue;
    } else {
      return title;
    }
  };

  const addNewBlockHandler = () => {
    // Check if blockArray length is greater than or equal to 5
    if (blockArray.length >= surveyFormValue?.SURVEY_BLOCK_LIMIT) {
      toastMessage(SURVEY_BLOCK_MORE_THAN_LIMIT, "warning", "add-new-block");
      return;
    } else {
      let updatedBlockName = `Section ${blockArray?.length + 1}`;

      setSurveyQuestionArray((prevState) => ({
        ...prevState,
        [updatedBlockName.trim()]: [], // Initialize with an empty array or any default value
      }));

      setBlockArray([
        ...blockArray,
        {
          title: "",
          totalQuestion: 0,
          name: updatedBlockName.trim(),
        },
      ]);
      setTitleValue("");
      setSelectedBlock(updatedBlockName.trim());
    }
  };

  const disablePreviewHandler = (e) => {
    e.preventDefault();
    // let isValid = surveyQuestionArray[selectedBlock]

    // if()

    setSurveyPreviewModel(true);

    // question;
  };

  //---------------------------------- Handle All HTML CODE ----------------------------------//
  return (
    <>
      <div className="survey_fields customize_question">
        <div className="form_wrap">
          <div className="form_content">
            <div className="top_title">
              <ul>
                {blockArray?.length > 0 &&
                  blockArray.map((block, index) => (
                    <li
                      key={`${block?.name}${index}`}
                      className={selectedBlock === block?.name ? "active" : ""}
                      // onDoubleClick={() => renameBlockTitleHandler(block?.name)}
                    >
                      <button
                        type="button"
                        className="text"
                        onClick={() => {
                          setTitleValue("");
                          setSelectedBlock(block?.name);
                        }}
                      >
                        {/* {block?.name} */}
                        {t(`CUSTOMIZATION_QUESTION.${block?.name}`)}
                      </button>
                      {blockArray?.length > 1 && (
                        <span
                          className="close_button"
                          onClick={() =>
                            deleteBlockHandler(
                              t(`CUSTOMIZATION_QUESTION.${block?.name}`)
                            )
                          }
                        >
                          <FaTimes />
                        </span>
                      )}
                    </li>
                  ))}
              </ul>

              <button
                type="button"
                className="add_block_button"
                onClick={addNewBlockHandler}
              >
                <MdAdd />
                {t("CUSTOMIZATION_QUESTION.addNewSection")}
              </button>
            </div>

            {/*-------------------- Section Title code --------------------*/}
            <div className="form_field">
              <TextAreaAutoAdjust
                // label="Title"
                name="question"
                maxLength={500}
                style={{ resize: "none" }}
                value={titleValueHandler(selectedBlock)}
                placeholder={`${t(`CUSTOMIZATION_QUESTION.enterTitle`)} ${t(
                  `CUSTOMIZATION_QUESTION.${selectedBlock}`
                )} `}
                onChange={(e) => blockTitleOnChangeHandler(e, selectedBlock)}
              />
            </div>

            <div className="create_questions">
              <DndContext
                sensors={sensors}
                onDragEnd={handleDragEnd}
                collisionDetection={closestCenter}
                modifiers={[restrictToVerticalAxis]}
              >
                <SortableContext
                  strategy={verticalListSortingStrategy}
                  items={surveyQuestionArray[selectedBlock] || []}
                >
                  <div>
                    {!isObjectEmpty(surveyQuestionArray) &&
                      !isArrayEmpty(surveyQuestionArray[selectedBlock]) &&
                      surveyQuestionArray[selectedBlock]?.map(
                        (question, index) => (
                          <div
                            key={`${question?.questionType}-${question?.questionNumber}-${selectedBlock}`}
                          >
                            {getSurveyQuestion(question, index)}
                          </div>
                        )
                      )}
                  </div>
                </SortableContext>
              </DndContext>

              {/* Generate Your Survey with AI */}
              {!isObjectEmpty(surveyQuestionArray) &&
                Object.values(surveyQuestionArray).every(
                  (blockQuestions) =>
                    !blockQuestions || blockQuestions.length === 0
                ) && (
                  <div className="form_field">
                    <Button
                      disabled={true}
                      className="has_icon w-100 light"
                      onClick={() => setSurveyAIModel(true)}
                    >
                      <img src={AIIcon} alt="" />{" "}
                      {t(`CUSTOMIZATION_QUESTION.generateSurveyAI`)}
                    </Button>
                  </div>
                )}

              {/* Select question type */}
              <div className="question_type">
                <div className="form_field">
                  {showDropdown || (
                    <Button
                      className="has_icon w-100 light"
                      onClick={handleShowQuestionDropdown}
                    >
                      <img src={addIcon} alt="" />{" "}
                      {t(`CUSTOMIZATION_QUESTION.addQuestion`)}
                    </Button>
                  )}

                  {showDropdown && (
                    <Button
                      className="has_icon w-100 light"
                      onClick={() => setShowDropdown(false)}
                    >
                      <img src={addIcon} alt="" className="cancel" />{" "}
                      {t(`CUSTOMIZATION_QUESTION.addQuestion`)}
                    </Button>
                  )}
                </div>

                {/* setShowDropdown */}

                {showDropdown && (
                  <DropdownQuestionType
                    blockArray={blockArray}
                    setBlockArray={setBlockArray}
                    showDropdown={showDropdown}
                    selectedBlock={selectedBlock}
                    setShowDropdown={setShowDropdown}
                    questionArray={surveyQuestionArray}
                    allPrevQuestionCount={allPrevQuestionCount}
                    setSurveyQuestionArray={setSurveyQuestionArray}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="form_summery_wrap">
            {/* <div className="form_summery my-4">
              <LoadingButton
                className="w-100 has_icon light"
                onClick={saveSurveyInDraftHandler}
                loading={mcqQuestionUploadLoader}
              >
                Save in Draft <FaArrowRight />
              </LoadingButton>
            </div> */}

            <div className="form_summery">
              <LoadingButton
                className="w-100 has_icon"
                onClick={createSurveyHandler}
                loading={mcqQuestionUploadLoader}
              >
                {t(`CUSTOMIZATION_QUESTION.saveNext`)}
                {/* <FaArrowRight /> */}
                <IoMdArrowForward />
              </LoadingButton>
            </div>

            <div className="button_wrap">
              <Link
                // to="/dashboard/create-survey/preview"
                to="#"
                onClick={disablePreviewHandler}
                className="w-100 light button has_icon icon_left"
              >
                {/* <FaEye /> */}
                <IoEyeOutline />
                {t(`CUSTOMIZATION_QUESTION.previewSurvey`)}
              </Link>

              <Button
                onClick={() => setIsDaftModalOpen(true)}
                className="w-100  light has_icon icon_left"
              >
                {/* <FaArrowLeft /> */}
                <IoArrowBackSharp />
                {t(`CUSTOMIZATION_QUESTION.exitTask`)}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Add New Block Model */}
      {addBlockModel && (
        <CustomModal
          className={""}
          show={addBlockModel}
          handleClose={closeModal}
        >
          <AddNewBlock
            blockArray={blockArray}
            closeModal={closeModal}
            setTitle={setTitleValue}
            setBlockArray={setBlockArray}
            setSelectedBlock={setSelectedBlock}
            surveyQuestionArray={surveyQuestionArray}
            setSurveyQuestionArray={setSurveyQuestionArray}
          />
        </CustomModal>
      )}

      {/* Rename Block Title */}
      {renameBlockTitleModal && (
        <CustomModal
          show={renameBlockTitleModal}
          handleClose={closeModal}
          className={""}
        >
          <RenameExistblock
            closeModal={closeModal}
            selectedBlock={selectedBlock}
            setBlockArray={setBlockArray}
            setSelectedBlock={setSelectedBlock}
            surveyQuestionArray={surveyQuestionArray}
            setSurveyQuestionArray={setSurveyQuestionArray}
          />
        </CustomModal>
      )}

      {/* Delete Selected Modal */}
      {deleteBlockModel && (
        <DeleteModal
          show={deleteBlockModel}
          handleClose={closeModal}
          deleteHandler={selectedDeleteBlockHandler}
          title={`${t("CUSTOMIZATION_QUESTION.deleteSelectedBlock")} ${
            deletedBlock || ""
          }?`}
        />
      )}

      {/* Survey Preview Model */}
      {surveyPreviewModel && (
        <CustomModal
          show={surveyPreviewModel}
          handleClose={closeModal}
          className={"surveyPreviewModal"}
        >
          <div className="survey_preview_device">
            <div className="dashboard_title">
              <h3>{t(`CUSTOMIZATION_QUESTION.previewSurvey`)}</h3>
            </div>
            <div className="mobile_frame_wrap">
              <DeviceFrameset device="iPhone X">
                <div className="survey_question_preview">
                  <div className="question_wrap">
                    <SurveyPreview
                      showAnswer={false}
                      surveyBlocks={blockArray}
                      surveyMcq={surveyQuestionArray || {}}
                    />
                  </div>
                  <p className="poweredBy">
                    {t(`CUSTOMIZATION_QUESTION.powerByBirt`)}
                  </p>
                </div>
              </DeviceFrameset>
            </div>
          </div>
        </CustomModal>
      )}

      {/* Generate Survey With Ai */}
      {surveyAIModel && (
        <CustomModal
          show={surveyAIModel}
          handleClose={closeModal}
          className={""}
        >
          <AiSuveyModel />
        </CustomModal>
      )}

      {/* {isDaftModalOpen && (
        <DeleteModal
          show={isDaftModalOpen}
          handleClose={() => setIsDaftModalOpen(false)}
          // deleteHandler={selectedDeleteBlockHandler}
          title={`Are You want to your data in draft ?`}
        />
      )} */}

      {/* save draft confirm modal */}
      <CustomModal
        className={""}
        show={isDaftModalOpen}
        handleClose={() => setIsDaftModalOpen(false)}
      >
        <>
          <h4>{t(`CUSTOMIZATION_QUESTION.saveDraftDescription`)}</h4>
          <div className="button_wrap button_center">
            <LoadingButton
              loading={draftButtonLoading}
              onClick={saveSurveyInDraftHandler}
            >
              {t(`CUSTOMIZATION_QUESTION.saveDraft`)}
            </LoadingButton>

            <Button className={"light"} onClick={exitSurveyHandler}>
              {t(`CUSTOMIZATION_QUESTION.exit`)}
            </Button>
          </div>
        </>
      </CustomModal>
    </>
  );
};

export default CustomizeQuestionIndex;
